import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ClientDocumentTitle} from 'src/pages/Modules/Clients/shared/clientHelpers';
import {ClientForm} from 'src/pages/Modules/Clients/shared/ClientForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const ClientCreatePage = () => {
  useSetDocumentTitle(ClientDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Clients}>
      <ClientForm mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ClientsCreate(),
  element: <ClientCreatePage />,
  module: ModuleEnum.Clients,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
